import React from "react";
import Seo from "@/components/Seo";
import { useLang } from "@/context/LanguageContext";
import { Flame } from "lucide-react";

export default function Login() {
  const { t } = useLang();
  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/profile";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <>
      <Seo title={t("login")} canonicalPath="/login" />
      <div className="max-w-md mx-auto px-6 py-24 text-center">
        <Flame className="w-12 h-12 text-amber-500 mx-auto mb-6" />
        <h1 className="font-serif text-3xl text-amber-100 mb-3">{t("login")}</h1>
        <p className="text-stone-400 mb-8">{t("login_desc")}</p>
        <button data-testid="google-login-btn" onClick={handleLogin} className="w-full bg-gradient-to-r from-amber-600 to-amber-700 hover:from-amber-500 hover:to-amber-600 text-stone-950 font-semibold px-6 py-3.5 rounded-md shadow-lg transition-all border border-amber-400/30">
          {t("login_google")}
        </button>
      </div>
    </>
  );
}
